module.exports = __webpack_public_path__ + "static/media/community-first@3x.9e3bbf30.jpg";